import { useState } from 'react';
import './DangerousReportDialog.css';
import { commentsAPI } from './services/api';

function DangerousReportDialog({ event, onClose, onSubmitSuccess }) {
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!message.trim()) {
      alert('Please describe your concerns before submitting');
      return;
    }

    try {
      setSubmitting(true);

      const commentData = {
        communityEventId: event.id,
        message: message.trim(),
        reaction: null,
        type: 2
      };

      const createdComment = await commentsAPI.create(commentData);

      alert('Your concern has been reported. Thank you for keeping the community safe.');

      if (onSubmitSuccess) {
        onSubmitSuccess(createdComment);
      }

      onClose();
    } catch (error) {
      console.error('Error submitting report:', error);
      const errorMessage = error.response?.data?.title ||
                           error.response?.data ||
                           'Failed to submit your report. Please try again.';
      alert(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="dangerous-report-overlay" onClick={onClose}>
      <div className="dangerous-report-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>Report Concern</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="dialog-body">
          <p className="event-name">Event: <strong>{event.name}</strong></p>
          <p className="helper-text">
            Please describe why you think this event might be dangerous or concerning.
            Your feedback helps keep the community safe.
          </p>

          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Describe your concerns here..."
            maxLength={2000}
            rows={6}
            autoFocus
          />

          <div className="char-count">
            {message.length} / 2000 characters
          </div>
        </div>

        <div className="dialog-footer">
          <button className="cancel-btn" onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button
            className="submit-btn"
            onClick={handleSubmit}
            disabled={submitting || !message.trim()}
          >
            {submitting ? 'Submitting...' : 'Submit Report'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DangerousReportDialog;
